import React from 'react';
import './CareDelivery.css';

function CareDelivery({ onCardClick }) {
  const cards = [
    {
      id: 1,
      icon: '/images/icons/landing-how-care-icon-1.png',
      titleLine1: '24/7 Fast ',
      serifText: 'Access',
      titleLine2: 'To Care',
      description: 'Get Medical Support When And Where You Need It, With No Waitlists Or Delays.',
      variant: 'blue'
    },
    {
      id: 2,
      icon: '/images/icons/landing-how-care-icon-2.png',
      titleLine1: 'Personalized Case ',
      serifText: 'Management',
      titleLine2: '',
      description: 'A Dedicated Team That Ensures Continuity, Coordination, And Clarity Across Every Touchpoint Of Your Care.',
      variant: 'grey'
    },
    {
      id: 3,
      icon: '/images/icons/landing-how-care-icon-3.png',
      titleLine1: 'Focus On Longevity ',
      serifText: 'And Prevention',
      titleLine2: '',
      description: "We Don't Just Treat. We Plan, Prevent, And Optimize Long Before Symptoms Arise.",
      variant: 'dark'
    }
  ];

  return (
    <section className="ttc-care-main-wrapper py-5">
      <div className="container py-lg-4">
        <div className="text-center mb-5">
          <h2 className="ttc-care-heading">
            We're Revolutionizing <span className="ttc-care-heading-italic">How Care Is Delivered</span>
          </h2>
        </div>

        <div className="row gy-4 justify-content-center">
          {cards.map((card) => (
            <div key={card.id} className="col-12 col-md-6 col-lg-4 d-flex">
              <div 
                className={`ttc-care-card ttc-care-card-${card.variant} w-100`}
                onClick={onCardClick}
                role="button"
                tabIndex={0}
              >
                <div className="ttc-care-icon-box mb-4">
                  <img src={card.icon} alt="" className="img-fluid" />
                </div>

                
                <div className="ttc-care-card-body">
                  <h3 className="ttc-care-card-title mb-3">
                    {card.titleLine1}
                    {card.serifText && (
                      <span className="ttc-care-title-serif">{card.serifText}</span>
                    )}
                    {card.titleLine2 && (
                      <>
                        <br />
                        {card.titleLine2}
                      </>
                    )}
                  </h3>

                  <p className="ttc-care-card-desc mb-0">{card.description}</p>
                </div>

                
                <div className="ttc-care-notch-container">
                  <div className={`ttc-care-notch-btn ttc-care-btn-${card.variant}`}>
                    <svg 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="7" y1="17" x2="17" y2="7"></line>
                      <polyline points="7 7 17 7 17 17"></polyline>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareDelivery;